import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import GrantAccessButtons from "../GrantAccessButtons/GrantAccessButtons";
import TruncatedGridCell from "../../../../Common/components/TruncatedGridCell";

export const getPendingRequestsColumns = (): GridColDef[] => {
  return [
    {
      field: "icon",
      headerName: "",
      width: 30,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: GridRenderCellParams<string>) => {
        return <AccessTimeRoundedIcon color={"info"} />;
      },
    },
    {
      field: "memberName",
      headerName: "Name",
      disableColumnMenu: true,
      flex: 0.8,
      renderCell: (params: GridRenderCellParams<string>) => {
        const memberName = params.value as string;
        return <TruncatedGridCell value={memberName} placement="top-start" />;
      },
    },
    {
      field: "memberEmail",
      headerName: "Email",
      flex: 0.9,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<string>) => {
        const memberEmail = params.value as string;
        return <TruncatedGridCell value={memberEmail} placement="top-start" />;
      },
    },
    {
      field: "projectName",
      headerName: "Project",
      flex: 0.9,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<string>) => {
        const projectName = params.value as string;
        return <TruncatedGridCell value={projectName} placement="top-start" />;
      },
    },
    {
      field: "role",
      headerName: "Role",
      flex: 0.9,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<string>) => {
        const role = params.value as string;
        return <TruncatedGridCell value={role} placement="top-start" />;
      },
    },
    {
      field: "actions",
      headerName: "Grant Access",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: GridRenderCellParams<string>) => {
        return (
          <GrantAccessButtons
            projectId={params.row.projectId}
            memberId={params.row.memberId}
          />
        );
      },
    },
  ];
};
